var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 33,
    viewBox: "0 0 57 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H38V4.71429H19V0ZM9.5 9.42857V4.71429H19V9.42857H9.5ZM4.75 14.1429V9.42857H9.5V14.1429H4.75ZM4.75 18.8571V14.1429H0V18.8571H4.75ZM9.5 23.5714H4.75V18.8571H9.5V23.5714ZM19 28.2857H9.5V23.5714H19V28.2857ZM38 28.2857V33H19V28.2857H38ZM47.5 23.5714V28.2857H38V23.5714H47.5ZM52.25 18.8571V23.5714H47.5V18.8571H52.25ZM52.25 14.1429H57V18.8571H52.25V14.1429ZM47.5 9.42857H52.25V14.1429H47.5V9.42857ZM47.5 9.42857V4.71429H38V9.42857H47.5ZM21.375 9.42857H26.125V14.1429H21.375V9.42857ZM30.875 14.1429H26.125V18.8571H21.375V23.5714H26.125V18.8571H30.875V23.5714H35.625V18.8571H30.875V14.1429ZM30.875 14.1429V9.42857H35.625V14.1429H30.875Z",
    fill: "#EE6C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector 4.a6147b0087e2021b14c9bfbe17b2de73.svg";
export { ForwardRef as ReactComponent };